import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../lib/session/session-context.js';
import { DashboardPage } from './dashboard-page.js';

/**
 * What "/" means depends on who opened it.
 *
 * A karigar signs in on their phone to find out what they are stitching today, and the shop
 * dashboard is a screen they hold no permission for anything on. Sending them straight to their
 * own work is not a shortcut — it is the entire product from where they stand.
 *
 * Everyone else gets the dashboard, unchanged.
 */
export function HomeRoute(): ReactElement {
  const session = useSession();
  if (session?.role === 'tailor') return <Navigate to="/my-work" replace />;
  return <DashboardPage />;
}

export default HomeRoute;
